




























import { ga } from '@app/componentlib/src/application/analytics'
import PdfViewer from '../components/PdfViewer.vue'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component<PdfSlider>({
  props: {
    url: String,
    width: Number,
    height: Number
  },
  components: {
    PdfViewer
  },
  watch: {
    url(value: string) {
      this.currentUrl = value
    }
  }
})

export default class PdfSlider extends Vue {
  /**
   * Props variables
   */
  url: string | undefined


  /**
   * Component state variables
   */
  slide = 1
  lastSlide: number | undefined = undefined
  currentUrl: string | undefined = undefined
  move = false

  /**
   * Lifecycle
   */
  mounted() {
    if (this.url !== undefined){
      this.currentUrl = this.url
      this.$forceUpdate()
    }
  }

  /**
   * Getters
   */

  /**
   * Methods
   */

  setPage (i: number) {
    this.slide = i
  }
  setPagecount (i: number) {
    this.lastSlide = i
    if(this.slide > this.lastSlide) {
      this.slide = this.lastSlide
    }
    this.$forceUpdate()
  }

  slideForward (where: string) {
    if(this.lastSlide !== undefined && this.lastSlide !== this.slide) {
      this.slide = this.slide+1
      ga.event({
        action: 'Preview slide',
        category: 'CV Tool',
        label: 'Forward ' + where
      })
    }
  }

  slideBack (where: string) {
    if(this.slide !== 0) {
      this.slide = this.slide-1
      ga.event({
        action: 'Preview slide',
        category: 'CV Tool',
        label: 'Back ' + where
      })
    }
  }
  changeSlide (i: number, where: string) {
    this.slide = i
    ga.event({
      action: 'Preview slide',
      category: 'CV Tool',
      label: where
    })
  }
}
